import IsLoadingIndicator from '../../isLoadingIndicator';

import PropTypes from 'prop-types';

export default function LoadingCard({ height = 330 }) {
  return (
    <div
      className="card p-2 rounded d-flex justify-content-center"
      style={{ height }}
    >
      <IsLoadingIndicator />
    </div>
  );
}

LoadingCard.propTypes = {
  height: PropTypes.number
};
